import Swiper, { Navigation, Pagination } from 'swiper'

const els = document.querySelectorAll('.element-quicklinks.as-slider')

export default {
  can: () => els.length,
  run: () => {
    els.forEach((el) => {
      const container = el.querySelector('.swiper')
      const numSlides = el.querySelectorAll('.swiper-slide').length

      if (numSlides > 1) {
        new Swiper(container, {
          slidesPerView: 2,
          slidesPerGroup: 2,
          modules: [Navigation, Pagination],
          pagination: {
            el: el.querySelector('.slider-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: el.querySelector('.slider-control-next'),
            prevEl: el.querySelector('.slider-control-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
            1024: {
              slidesPerView: 5,
              slidesPerGroup: 5,
            },
          },
        })
      }
    })
  },
}
